import axios from 'axios'
import merge from 'deepmerge'

export default class Api {
  constructor(){
    this.config = null
    this.axiosInstance = null
  }
  init(){
    this.config = merge(
      this._config(),
      this._defineConfig()
    )
    this.axiosInstance = this._createAxiosInstance()
    return this
  }
  defineApi(list){
    const createdApi = {list:()=>{console.table(list)}}
    const exceptionBody = ['get', 'delete', 'head']
    list.forEach(({ method, name, url }) => {
      if(exceptionBody.includes(method)){
        createdApi[name] = (config)=>{
          return this.axiosInstance[method](url, config)
        }
      }else{
        createdApi[name] = (body, config)=>{
          return this.axiosInstance[method](url, body, config)
        }
      }
    });
    return createdApi
  }

  // インスタンス共通設定
  _config(){
    return {
      'timeout': 60000
    }
  }
  _requestBefore(config){
    config.url = this._bindParamsInUrl(config.url, config.custom)
    return this._defineRequestBefore(config)
  }
  _requestError(error){
    return this._defineRequestError(error)
  }
  _responseBefore(response){
    return this._defineResponseBefore(response)
  }
  _responseError(error){
    this._networkError(error)
    return this._defineResponseError(error)
  }
  _networkError(error){
    if(error.code !== 'ERR_NETWORK') return false
    this._defineNetworkError(error)
  }
  
  // インスタンス毎に拡張
  _defineConfig(){
    return {}
  }
  _defineRequestBefore(config){
    return config
  }
  _defineRequestError(error){
    return Promise.reject(error)
  }
  _defineResponseBefore(response){
    return response
  }
  _defineResponseError(error){
    return Promise.reject(error)
  }
  _defineNetworkError(error){
  }
  
  _bindParamsInUrl(url, customConfig){
    if( !(typeof customConfig !== 'undefined' && typeof customConfig.params !== 'undefined') ) return url

    let boundUrl = url;
    Object.keys(customConfig.params).forEach((param)=>{
      const reg = new RegExp(`:${param}`)
      boundUrl = boundUrl.replace(reg,customConfig.params[param])
    })
    return boundUrl
  }
  _createAxiosInstance(){
    const axiosInstance = axios.create(this.config)
    axiosInstance.interceptors.request.use(
      this._requestBefore.bind(this),
      this._requestError.bind(this)
    )
    axiosInstance.interceptors.response.use(
      this._responseBefore.bind(this),
      this._responseError.bind(this)
    )
    return {
      request   : (config = {}) => axiosInstance.request(config),
      head      : (url, config = {}) => axiosInstance.head(url, config),
      get       : (url, config = {}) => axiosInstance.get(url, config),
      delete    : (url, config = {}) => axiosInstance.delete(url, config),
      post      : (url, body, config = {}) => axiosInstance.post(url, body, config),
      put       : (url, body, config = {}) => axiosInstance.put(url, body, config),
      patch     : (url, body, config = {}) => axiosInstance.patch(url, body, config),
      postForm  : (url, body, config = {}) => axiosInstance.postForm(url, body, config),
      putForm   : (url, body, config = {}) => axiosInstance.putForm(url, body, config),
      patchForm : (url, body, config = {}) => axiosInstance.patchForm(url, body, config),
    }
  }
}
